'use client';
import * as React from 'react';
import { createContext, useContext } from 'react';

/**
 * Lightweight theme provider that forces light mode.
 * Replaces next-themes to avoid the <script> tag warning in Next.js 16.
 * Since this site is always light-themed, no theme switching logic is needed.
 */
const ThemeContext = createContext({ theme: 'light', setTheme: (_theme: string) => {} });

export function ThemeProvider({ children }: { children: React.ReactNode }) {
	return <ThemeContext.Provider value={{ theme: 'light', setTheme: () => {} }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
